// 单文件引入方式

import ZuiPopup from './ZuiPopup.vue'

export default {
  install(Vue) {
    Vue.component('ZuiPopup', ZuiPopup)
  }
}
